export * from "./generateCancellationPenaltyFormattedText";
export const NOT_IMPLEMENTED = "Cannot parse this type of penalty";
